import { SortItemsType } from '@shared/interfaces/list-fields.interface';

export const AbsenceRequestsSortFields: SortItemsType[] = [
  {
    description: '',
    key: 'checkbox',
    styles: {
      min: 32,
      flex: '0 0 32px'
    }
  },
  {
    description: '',
    key: 'logo',
    templateRefKey: 'fieldLogo',
    styles: {
      min: 55,
      flex: '0 0 55px'
    }
  },
  {
    description: 'ID',
    iconClass: 'sort-icon',
    key: 'id',
    sortType: 'user_id',
    positiveSort: 'user_id',
    negativeSort: '-user_id',
    templateRefKey: 'fieldId',
    styles: {
      min: 100,
      width: 100,
      flex: '0 0 10%'
    }
  },
  {
    description: 'Name',
    iconClass: 'sort-icon',
    key: 'name',
    sortType: 'name',
    positiveSort: 'name',
    negativeSort: '-name',
    templateRefKey: 'fieldName',
    styles: {
      min: 100,
      width: 100,
      flex: '1 1 0%'
    }
  },
  {
    description: 'Type',
    key: 'type',
    templateRefKey: 'fieldType',
    styles: {
      min: 100,
      width: 100,
      flex: '1 1 0%'
    }
  },
  {
    description: 'Period',
    key: 'period',
    templateRefKey: 'fieldPeriod',
    styles: {
      min: 100,
      width: 100,
      flex: '1 1 0%'
    }
  },
  {
    description: 'Options',
    key: 'options',
    clickable: false,
    templateRefKey: 'fieldOptions',
    styles: {
      min: 100,
      flex: '0 0 100px'
    }
  }
];
